<template>
    <div>
        <el-form ref="form" :model="form" label-width="137px" :rules="$rules.AddinterfaceRule">
            <el-row >
              <el-col  >
                     <el-form-item label="HTTP请求方式："  prop="reqMethod">
                       <el-select v-model="form.reqMethod" placeholder="请选择HTTP请求方式" style="width:100%;" filterable>
                            <el-option value="GET" label="GET"></el-option>
                            <el-option value="POST" label="POST"></el-option>
                            <el-option value="PUT" label="PUT"></el-option>
                            <el-option value="DELETE" label="DELETE"></el-option>
                            <el-option value="PATCH" label="PATCH"></el-option>
                            <el-option value="HEAD" label="HEAD"></el-option>
                            <el-option value="OPTIONS" label="OPTIONS"></el-option>
                            <el-option value="TRACE" label="TRACE"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col  >
                     <el-form-item label="权限类型：" prop="type">
                         <el-select v-model="form.type" placeholder="请选择权限类型" style="width:100%;" filterable clearable>
                            <el-option v-for="(value, key) in apiRuleTypeHub" v-bind:key="`api_rule_${key}`" :value="key" :label="`${key}（${value}）`"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col  >
                     <el-form-item label="路径规则：" prop="urlPattern">
                         <el-input type="text" placeholder="请输入路径规则" v-model="form.urlPattern" />
                    </el-form-item>
                </el-col>
                <el-col  >
                     <el-form-item label="约束类型：" prop="matchType">
                         <el-select v-model="form.matchType" placeholder="请选择约束类型" style="width:100%;" filterable clearable>
                            <el-option value="EQUAL" label="EQUAL"></el-option>
                            <el-option value="ANT" label="ANT"></el-option>
                            <el-option value="REGEX" label="REGEX"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col  >
                     <el-form-item label="子系统："  prop="modelId">
                        <el-select v-model="form.modelId" placeholder="请选择子系统" style="width:100%;" filterable clearable>
                          <el-option
                            v-for="item in SubsystemList"
                            :key="item.value"
                            :label="item.name"
                            :value="item.id">
                          </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col class="buttons">
                    <el-button @click="$emit('update:visibles',false)">取消</el-button>
                    <el-button type="primary" @click="submit()">提交</el-button>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>
<script>
import apiRule from '@/utils/apiRule'
export default {
  components: {

  },
  props: {
    type: {
      type: String
    },
    row: {
      type: Object
    }
  },
  data () {
    return {
      form: {},
      loading: false,
      departmentList: [],
      deptIds: null,
      apiRuleTypeHub: {
      },
      SubsystemList: []
    }
  },
  methods: {
    // 新增
    add_data () {
    },
    // 查询数据
    search_data (row, type) {
      this.matterParams.current = 1
      Object.assign(this.matterParams, row)
      this.Render()
    },
    // 列表按钮
    event_button (row, type) {
    },
    // 提交
    submit () {
      var that = this
      that.$refs.form.validate((valid) => {
        if (valid) {
          // eslint-disable-next-line no-unused-vars
          var Submitform = {}
          if (that.type === 'add') {
            Submitform = this.form
          } else if (this.type === 'edit') {
            Submitform = {
              id: that.form.id,
              matchType: that.form.matchType,
              modelId: that.form.modelId,
              reqMethod: that.form.reqMethod,
              urlPattern: that.form.urlPattern,
              type: that.form.type
            }
          }
          var RequestType = that.type === 'add' ? 'post' : 'post'
          var RequestTypeText = that.type === 'add' ? '添加' : '修改'
          var RequestUrl = that.type === 'add' ? '"/path/api-rule/save"' : '"/path/api-rule/save"'
          // eslint-disable-next-line
          eval(
                `that.$http.${RequestType}(${RequestUrl},${JSON.stringify(Submitform)}).then((res) => {
                    if(res.status == 200){
                        that.$message.success('${RequestTypeText}成功')
                        that.$emit('update:visibles',false)
                        that.$emit('Render')
                        sessionStorage.removeItem('dict.department.list')
                    } else {
                        that.$message.error('${RequestTypeText}失败')
                        that.$emit('update:visibles',true)
                    }
                })`
          )
        }
      })
    },
    // js暂停的方法
    sleep (interval) {
      return new Promise(resolve => {
        this.loading = true
        setTimeout(resolve, interval)
      })
    },
    async Layoutfun (query = '', data, Parameter1) {
      if (query !== '') {
        await this.sleep(150)
        this.loading = false
        // eslint-disable-next-line no-eval
        return data.filter(item => { return eval('item.' + Parameter1).toLowerCase().indexOf(query.toLowerCase()) > -1 })
      } else {
        return data.slice(0, 10)
      }
    },
    initApiRuleTypes () {
      // eslint-disable-next-line no-return-assign
      apiRule.apiRuleTypeObj(obj => this.apiRuleTypeHub = obj)
    },
    // 所属部门
    departmentRemoteMethod (query) {
      this.Layoutfun(query, this.$department.list(), 'name').then(res => {
        this.departmentList = res
        this.addValueOptions()
      })
    },
    // 修改回显问题
    addValueOptions () {
      if (this.deptIds) {
        const target = this.$department.list().find((item) => { // 从大option中找到当前条
          return item.id === this.deptIds
        })
        if (target) { // 将当前条与小option比对，没有则加入
          if (this.departmentList.every(item => item.id !== target.id)) {
            this.departmentList.unshift(target)
          }
        }
      }
    }
  },
  created () {
    this.SubsystemList = this.$Subsystem.list()
    if (this.type === 'edit') {
      this.form = JSON.parse(JSON.stringify(this.row))
      this.deptIds = this.form.deptId
    }
    this.departmentRemoteMethod()
    this.initApiRuleTypes()
  },
  watch: {
  },
  mounted () {
  }
}
</script>
<style lang="scss" scoped>
.buttons{
    text-align: center;
}
</style>
